import React from 'react';
import style from '../assets/styles/recipeDish.module.scss';
import Input from '../component/Input';
import CloseBtn from '../component/closeBtn';
import { getBtnData } from '../api/Api';
import Title from '../component/title.js';
import { Link } from 'react-router-dom';
import { alertMinimunAmount } from '../Helpers/Helpers.js';
import useRecipeIngredients from '../Hooks/useRecipeIngredients';

const RecipeDish = ({
  setRecipeModal,
  setRecipe,
  recipe, //object wiht contains raw material each size product and explanation
  customizedPriceObj,
  costByRecipe, //object which contains the cost and label for single size
  costProfitMarginCustomized, //object which contains the cost and label for each size
  onSingleCostUpdate,
  onCustomCostUpdate,
}) => {
  const [ingridients, setIngridients] = React.useState({
    name: '',
    amount: '',
    unitOfMeasurement: '',
  });

  const [recipeExplanation, setRecipeExplanation] = React.useState(null);
  const [productList, setProductList] = React.useState(null);

  const fieldFocus = React.useRef();

  const {
    ingredientsSimple,
    ingredientsBySize,
    addIngredient,
    removeItem,
    calculateItemCost,
    isEmptyObject,
  } = useRecipeIngredients(recipe, productList, customizedPriceObj);

  React.useEffect(() => {
    // Restaurando a busca de produtos (Estoque)
    const fetchProduct = async () => {
      const data = await getBtnData('stock');
      const sortedData = data
        .sort((a, b) => a.product.localeCompare(b.product))
        .filter(
          (item) =>
            item.operationSupplies === false &&
            (item.activityStatus === undefined ||
              item.activityStatus === false),
        );
      setProductList(sortedData);
    };
    fetchProduct();
  }, []);
  React.useEffect(() => {
    // Restaurando a inicialização da explicação da receita
    if (recipe && recipe.Explanation) {
      setRecipeExplanation(recipe.Explanation);
    }
  }, [recipe]);

  React.useEffect(() => {
    //#3
    calculateItemCost(ingredientsBySize);
    if (ingredientsBySize)
      console.log('ingredientsBySize    ', ingredientsBySize);
    if (ingredientsSimple)
      console.log('ingredientsSimple    ', ingredientsSimple);
  }, [ingredientsBySize, ingredientsSimple]);

  const grabSpecificItemInStock = (name) => {
    if (productList && productList.length > 0 && name) {
      const item = productList.find((item) => item.product === name);
      if (item) {
        const { product, totalVolume, minimumAmount, totalCost } = item;
        const warningAmountRawMaterial =
          totalVolume > minimumAmount ? true : false;
        const unavailableRawMaterial = totalVolume === 0 ? true : false;
        return {
          product,
          totalVolume,
          minimumAmount,
          totalCost,
          warningAmountRawMaterial,
          unavailableRawMaterial,
        };
      }
    }
    return null;
  };

  const extractLabelSizes = () => {
    return [
      customizedPriceObj.firstLabel,
      customizedPriceObj.secondLabel,
      customizedPriceObj.thirdLabel,
    ];
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    if (id === 'name') {
      const selectedProduct = productList[value];
      console.log('selectedProduct', selectedProduct);
      const disabledDish = Number(selectedProduct.disabledDish);
      const idProduct = selectedProduct.idProduct;
      const costPerUnit =
        selectedProduct && selectedProduct.totalVolume > 0
          ? selectedProduct.totalCost / selectedProduct.totalVolume
          : 0;

      const warningAmountRawMaterial =
        selectedProduct.totalVolume > selectedProduct.minimumAmount
          ? true
          : false;
      const unavailableRawMaterial =
        selectedProduct.totalVolume <= disabledDish ? true : false;

      setIngridients((prevForm) => ({
        ...prevForm,
        name: selectedProduct ? selectedProduct.product : '',
        idProduct: idProduct,
        unitOfMeasurement: selectedProduct
          ? selectedProduct.unitOfMeasurement
          : '',
        costPerUnit: costPerUnit,
        warningAmountRawMaterial: warningAmountRawMaterial,
        unavailableRawMaterial: unavailableRawMaterial,
        portionCost: prevForm.amount
          ? parseFloat(prevForm.amount) * costPerUnit
          : 0,
      }));
    } else {
      const normalizedValue = id === 'amount' ? value.replace(',', '.') : value;
      setIngridients({
        ...ingridients,
        [id]: normalizedValue,
      });
      if (id === 'amount') {
        const costPerUnit = ingridients.costPerUnit || 0;
        const newPortionCost = parseFloat(normalizedValue) * costPerUnit;
        setIngridients((prevForm) => ({
          ...prevForm,
          portionCost: isNaN(newPortionCost) ? 0 : newPortionCost,
        }));
      }
    }
  };

  const extractLabelSizesWithKeys = () => {
    return [
      { key: 'firstPrice', label: customizedPriceObj.firstLabel },
      { key: 'secondPrice', label: customizedPriceObj.secondLabel },
      { key: 'thirdPrice', label: customizedPriceObj.thirdLabel },
    ].filter(item => item.label); // Só mostra se tiver label
  };

  const sendRecipe = () => {
    // Lógica original de setRecipe
    if (!isEmptyObject(customizedPriceObj)) {
      setRecipe({
        FinalingridientsList: ingredientsBySize,
        Explanation: recipeExplanation,
      });
      // NOVO: Calcular e enviar custos customizados
      const costsUpdate = {};
      const PriceKeys = ['firstPrice', 'secondPrice', 'thirdPrice'];

      PriceKeys.forEach((priceKey) => {
        const cost = calculateItemCost(ingredientsBySize, priceKey);
        costsUpdate[priceKey] = { cost };
      });

      if (onCustomCostUpdate) onCustomCostUpdate(costsUpdate);
    } else {
      setRecipe({
        FinalingridientsList: ingredientsSimple,
        Explanation: recipeExplanation,
      });
      // NOVO: Calcular e enviar custo único
      const totalCost = calculateItemCost(ingredientsSimple);
      if (onSingleCostUpdate) onSingleCostUpdate(totalCost);
    }
    setRecipeModal(false);
  };

  // No componente visual
  const handleAddIngredient = (sizeKey) => {
    if (!ingridients.name || !ingridients.amount) {
      alert(
        'Todos os campos precisam ser preenchidos para que a receita funcione. Por favor, preencha o tipo da matéria-prima e a quantidade.',
      );
      return;
    }

    const amountNum = parseFloat(ingridients.amount.replace(',', '.'));
    const unit = (ingridients.unitOfMeasurement || '').toLowerCase().trim();

    // Verifica se a unidade é kg/L/unidade e o valor é >= 0.5, ou se é g/ml/grama/mililitro e o valor é >= 500
    const isLargeAmount = 
      ((unit === 'kg' || unit === 'l' || unit === 'quilo' || unit === 'litro' || unit === 'un' || unit === 'unidade') && amountNum >= 0.5) ||
      ((unit === 'g' || unit === 'ml' || unit === 'grama' || unit === 'mililitro') && amountNum >= 500);

    if (isLargeAmount) {
      const confirm = window.confirm(
        `Atenção: Você está tentando adicionar ${amountNum} ${ingridients.unitOfMeasurement} de "${ingridients.name}" na receita.\n` +
        `Isso equivale a 500g (ou 0.5kg/L) ou mais para uma única porção/receita de prato, o que é incomum.\n\n` +
        `Deseja confirmar e prosseguir com esta quantidade?`
      );
      if (!confirm) return;
    }

    addIngredient(ingridients, sizeKey); // Chama o do hook usando a chave fixa
    setIngridients({ name: '', amount: '', unitOfMeasurement: '' }); // Limpa UI
  };

  return (
    <div className={style.recipeDishContainer}>
      <CloseBtn setClose={setRecipeModal} />

      <Link to="/admin/admin">
        <Title mainTitle="Faça sua receita" />
      </Link>
      {isEmptyObject(customizedPriceObj) ? (
        <div>
          <div className={style.ingridients}>
            <select
              id="name"
              value={productList?.findIndex(
                (product) => product.product === ingridients.name,
              )}
              className={style.selectInput}
              onChange={handleChange}
            >
              <option value="">Selecione um produto</option>
              {productList &&
                productList.length > 0 &&
                productList.map((item, index) => (
                  <option key={index} value={index}>
                    {`${item.product}-${item.unitOfMeasurement}`}
                  </option>
                ))}
            </select>
            <input
              id="amount"
              fieldFocus={fieldFocus}
              placeholder="Quantidade"
              className={style.numberInput}
              value={ingridients.amount}
              type="text"
              onChange={handleChange}
            />

            <button type="button" onClick={() => handleAddIngredient()}>
              Adicione
            </button>
          </div>
          <div className={style.itemsRecipe}>
            <table>
              <thead>
                <tr>
                  <th>Produto</th>
                  <th>Quantidade</th>
                  <th>Valor cheio</th>
                  <th>Valor da porção</th>
                  <th>Excluir</th>
                </tr>
              </thead>
              <tbody>
                {ingredientsSimple &&
                  ingredientsSimple.map((item, index) => {
                    const itemData = grabSpecificItemInStock(item.name);

                    return (
                      <tr
                        key={index}
                        className={
                          itemData
                            ? alertMinimunAmount(
                              itemData.product,
                              itemData.totalVolume,
                              itemData.minimumAmount,
                              itemData.totalCost,
                            ).message
                              ? 'warning'
                              : ''
                            : ''
                        }
                      >
                        <td className="items">{item.name}</td>
                        <td className="items">
                          {item.amount}
                          {item.unitOfMeasurement}
                        </td>
                        <td className="items">
                          R${' '}
                          {item.costPerUnit
                            ? item.costPerUnit.toFixed(2)
                            : '0.00'}
                        </td>
                        <td className="items">
                          R${' '}
                          {item.portionCost
                            ? item.portionCost.toFixed(2)
                            : '0.00'}
                        </td>
                        <td
                          className="items"
                          style={{ cursor: 'pointer' }}
                          onClick={() => removeItem(index)}
                        >
                          x
                        </td>
                      </tr>
                    );
                  })}
              </tbody>

              <h2>Custo do produto {calculateItemCost(ingredientsSimple)}</h2>
            </table>
          </div>
        </div>
      ) : (
        extractLabelSizesWithKeys() &&
        extractLabelSizesWithKeys().length > 0 &&
        extractLabelSizesWithKeys().map(({ key, label }) => (
          <div className={style.recipeDisContainer} key={key}>
            <div className={style.ingridients}>
              {label}
              <select
                id="name"
                value={productList?.findIndex(
                  (product) => product.product === ingridients.name,
                )}
                className={style.selectInput}
                onChange={handleChange}
              >
                <option value="">Selecione um produto</option>
                {productList &&
                  productList.length > 0 &&
                  productList.map((item, index) => (
                    <option key={index} value={index}>
                      {`${item.product}-${item.unitOfMeasurement}`}
                    </option>
                  ))}
              </select>
              <input
                id="amount"
                fieldFocus={fieldFocus}
                placeholder="Quantidade"
                className={style.numberInput}
                value={ingridients.amount}
                type="text"
                onChange={handleChange}
              />

              <button type="button" onClick={() => handleAddIngredient(key)}>
                Adicione
              </button>
            </div>
            <div className={style.itemsRecipe}>
              <table>
                <thead>
                  <tr>
                    <th>Produto</th>
                    <th>Quantidade</th>
                    <th>Valor cheio</th>
                    <th>Valor da porção</th>
                    <th>Excluir</th>
                  </tr>
                </thead>
                <tbody>
                  {ingredientsBySize &&
                    ingredientsBySize[key]?.map((item, index) => {
                      const itemData = grabSpecificItemInStock(item.name);

                      return (
                        <tr
                          key={index}
                          className={
                            itemData
                              ? alertMinimunAmount(
                                itemData.product,
                                itemData.totalVolume,
                                itemData.minimumAmount,
                                itemData.totalCost,
                              ).message
                                ? 'warning'
                                : ''
                              : ''
                          }
                        >
                          <td className="items">{item.name}</td>
                          <td className="items">
                            {item.amount}
                            {item.unitOfMeasurement}
                          </td>
                          <td className="items">
                            R${' '}
                            {item.costPerUnit
                              ? item.costPerUnit.toFixed(2)
                              : '0.00'}
                          </td>
                          <td className="items">
                            R${' '}
                            {item.portionCost
                              ? item.portionCost.toFixed(2)
                              : '0.00'}
                          </td>
                          <td
                            className="items"
                            style={{ cursor: 'pointer' }}
                            onClick={() => removeItem(key, index)}
                          >
                            x
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
              <h2>
                Custo do produto ({label}): R${' '}
                {calculateItemCost(ingredientsBySize, key)}
              </h2>
            </div>
          </div>
        ))
      )}
      <div className={style.textAreaContainer}>
        <label>Escreva sua receita</label>
        <textarea
          id="gift"
          required
          className={style.textArea}
          value={recipeExplanation}
          onChange={(e) => setRecipeExplanation(e.target.value)}
        />
      </div>
      <div className={style.formButtonSubmit}>
        <button onClick={sendRecipe}>Enviar Receita</button>
      </div>
    </div>
  );
};
export default RecipeDish;
